//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import { MediaFilterParamKey } from '@apis/content-library/contentLibraryApiModel';
import HR from '@components/atoms/hr/HR';
import { CheckboxSetFilter } from '@components/media-filters/CheckboxSetFilter';
import { CollapsibleSection } from '@components/media-filters/CollapsibleSection';
import {
  FilterSection,
  FilterSectionTitle,
  FilterValue,
} from '@components/media-filters/filterSectionModels';
import { MediaLibraryTrackingIds } from '@media-library/constants/mediaLibraryTrackingIds';

export interface SpamFilterProps {
  isInitiallyCollapsed?: boolean;
  section: FilterSection<boolean> | undefined;
  onChange: (
    sections: Map<MediaFilterParamKey, FilterSection<FilterValue>>,
  ) => void;
}

export const DEFAULT_SPAM_FILTER_SECTION: FilterSection<boolean> = {
  options: [
    {
      isSelected: false,
      label: 'Filter out spam',
      value: true,
      trackingId: MediaLibraryTrackingIds.SPAM_FILTERING_CHECKBOX,
    },
  ],
  paramKey: 'spamFiltering',
};

export const SpamFilter = ({
  isInitiallyCollapsed,
  onChange,
  section = DEFAULT_SPAM_FILTER_SECTION,
}: SpamFilterProps) => (
  <>
    <CollapsibleSection
      isCollapsed={isInitiallyCollapsed}
      title={FilterSectionTitle[section.paramKey]}
    >
      <CheckboxSetFilter onChange={onChange} section={section} />
    </CollapsibleSection>
    <HR />
  </>
);
